import { createContext, useCallback, useContext, useMemo } from 'react';
export const FieldTemporaryValuesContext = /*#__PURE__*/createContext(null);
export const useTemporaryValue = target => {
  const context = useContext(FieldTemporaryValuesContext);
  if (!context) {
    throw new Error('useTemporaryValue must be used within a TemporaryValueProvider');
  }
  const {
    values,
    setValues
  } = context;
  const currentValue = values[target];
  const memoisedValue = useMemo(() => currentValue, [currentValue]);
  const setValue = useCallback(newValue => {
    setValues(oldValues => ({
      ...oldValues,
      [target]: newValue
    }));
  }, [setValues, target]);
  return [memoisedValue, setValue];
};
//# sourceMappingURL=field-temporary-value-context.js.map